import React from "react";

const FormSectionPreview = props => {
  const {children, title, show} = props;
  return show ? (
    <div className="row mb-4">
      <div className="col-12">
        <h5 className="w-100 text-blue-cermaq my-4">{title}</h5>
      </div>
      <div className="col-12">
        <div className="border-top border-bottom py-3">{children}</div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default FormSectionPreview;
